import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Chapter1 from "../views/Chapter1.vue";
import Chapter2 from "../views/Chapter2.vue";
import Chapter3 from "../views/Chapter3.vue";
import Chapter4 from "../views/Chapter4.vue";
import Chapter5 from "../views/Chapter5.vue";
import Chapter6 from "../views/Chapter6.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/la-amenaza",
    name: "Chapter1",
    component: Chapter1
  },
  {
    path: "/la-respuesta",
    name: "Chapter2",
    component: Chapter2
  },
  {
    path: "/la-respuesta-estados",
    name: "Chapter3",
    component: Chapter3
  },
  {
    path: "/la-amenaza-privilegio",
    name: "Chapter4",
    component: Chapter4
  },
  {
    path: "/las-consecuencias-llamadas",
    name: "Chapter5",
    component: Chapter5
  },
  {
    path: "/el-exceso-de-mortalidad",
    name: "Chapter6",
    component: Chapter6
  },
  {
    path: "/sobre-coronavirus",
    redirect: "/la-amenaza"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
  }
});

export default router;
